const topics = [
  { title: '明星八卦', desc: '最新明星恋情、绯闻、家庭动态一手掌握', count: 326, color: 'bg-primary-100 text-primary-700' },
  { title: '网红事件', desc: '网红圈争议、翻车、互撕全程追踪', count: 218, color: 'bg-accent-100 text-accent-800' },
  { title: '黑料网曝', desc: '独家爆料、内幕消息、深扒真相', count: 157, color: 'bg-secondary-100 text-secondary-800' },
  { title: '综艺热话', desc: '热门综艺争议片段、幕后花絮解读', count: 203, color: 'bg-primary-100/60 text-primary-700' },
  { title: '影视剧透', desc: '新剧路透、片场趣事、收视排行', count: 189, color: 'bg-accent-100/60 text-accent-800' },
  { title: '社会热点', desc: '网络热门社会事件深度挖掘与分析', count: 271, color: 'bg-secondary-100/70 text-secondary-800' },
  { title: '音乐风云', desc: '歌手动态、新歌发布、演唱会幕后', count: 142, color: 'bg-primary-100/50 text-primary-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-label tracking-wider text-accent-600 bg-accent-100 px-4 py-1.5 rounded-full mb-4 whitespace-nowrap">
            热门专题
          </span>
          <h2 className="font-heading text-[32px] md:text-[40px] text-foreground-950">吃瓜索引</h2>
          <p className="text-sm text-foreground-500 mt-3">全站最热专题合集，一键直达你关心的每一个瓜</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {topics.slice(0, 4).map((topic, i) => (
            <a
              key={i}
              href={`#topics`}
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }}
              className="group block bg-background-50 border border-background-200/70 rounded-2xl p-5 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className={`inline-flex items-center gap-2 ${topic.color} text-xs font-medium px-3 py-1 rounded-full mb-4 whitespace-nowrap`}>
                <i className="ri-fire-line"></i>
                {topic.count}篇
              </div>
              <h3 className="font-heading text-lg text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">{topic.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{topic.desc}</p>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5 mt-4 md:mt-5">
          {topics.slice(4).map((topic, i) => (
            <a
              key={i}
              href={`#topics`}
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }}
              className="group block bg-background-50 border border-background-200/70 rounded-2xl p-5 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className={`inline-flex items-center gap-2 ${topic.color} text-xs font-medium px-3 py-1 rounded-full mb-4 whitespace-nowrap`}>
                <i className="ri-fire-line"></i>
                {topic.count}篇
              </div>
              <h3 className="font-heading text-lg text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">{topic.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{topic.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}